import React from 'react';
import { Link } from 'react-router-dom';
import innovativePackagingData from '../../../data/innovativePackagingData';
import SEO from '../../../components/SEO';
import '../ProductDetail.css';

const categoryOrder = ['paper-cushioning', 'air-cushioning', 'foam-packaging'];

const InnovativeProtectivePackaging = () => {
  return (
    <div className="product-detail-page">
      <SEO
        title="Innovative Protective Packaging"
        description="On-demand paper, air, and foam cushioning systems from Tirupati Enterprises — smart, sustainable protective packaging for every product."
        path="/products/innovative-protective-packaging"
      />
      {/* Hero Section */}
      <section className="product-detail-hero" style={{ backgroundImage: "url('/images/innovativepackaging/air/airmove.webp')" }}>
        <div className="product-detail-hero-overlay"></div>
        <div className="container">
          <h1 className="product-detail-hero-title">Innovative Protective Packaging</h1>
        </div>
      </section>

      {/* Main Title */}
      <section className="product-detail-intro">
        <div className="container">
          <h2 className="product-detail-main-title">
            Smart, On-Demand Cushioning Systems for Every Product
          </h2>
        </div>
      </section>

      {/* Introduction */}
      <section className="product-intro-section">
        <div className="container">
          <div className="intro-content-full">
            <p className="intro-paragraph">
              At <strong>Tirupati Enterprises</strong>, our Innovative Protective Packaging range covers paper, air,
              and foam-based cushioning systems that generate protective material right at the packing station.
              These systems reduce excess material use, cut down on storage space, and adapt to a wide range of
              product shapes and sizes.
            </p>
            <p className="intro-paragraph">
              Explore the three cushioning categories below to find the right fit for your packaging line.
            </p>
          </div>
        </div>
      </section>

      {/* Category Cards */}
      <section className="box-types-section">
        <div className="container">
          <div className="box-types-grid">
            {categoryOrder.map((slug) => {
              const category = innovativePackagingData[slug];
              return (
                <div key={slug} className="box-type-card">
                  <div className="box-type-image">
                    <img
                      src={category.image || category.products[0].image}
                      alt={category.title}
                    />
                  </div>
                  <div className="box-type-content">
                    <h3 className="box-type-title">{category.title}</h3>
                    <p className="box-type-desc">{category.subtitle}</p>
                    <Link
                      to={`/products/innovative-protective-packaging/${slug}`}
                      className="box-type-link-btn"
                    >
                      View Options
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Need Guidance */}
      <section className="why-applications-section">
        <div className="container">
          <div className="why-applications-grid single-column">
            <div className="applications-column">
              <h2 className="section-title">Need guidance?</h2>
              <p className="intro-paragraph">
                Let our team help you choose the right cushioning system for your product and packing line.
              </p>
              <Link to="/contact" className="btn-cta-primary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnovativeProtectivePackaging;
